import { Form, Separator } from '@thinknet-gmbh/platform-common-ui';

import { InterviewFormWrapper } from './applicant-interviews-form-list.styles';
import { InterviewFormItems } from './interview-form-items';

const ApplicantInterviewsFormList = ({
  isAddedAdditionalInterview,
  t,
  fieldName,
  hideActionButtons,
}: {
  isAddedAdditionalInterview?: boolean;
  fieldName?: string;
  t: Function;
  hideActionButtons?: () => void;
}) => (
  <Form.List name={fieldName || 'interviews'}>
    {(fields, actions) =>
      fields.map(field => (
        <InterviewFormWrapper key={field.key}>
          {field.name === 0 && <Separator />}
          <InterviewFormItems
            actions={actions}
            parentField={field.name}
            title={t('vacancies:labels.interviewDetails')}
            feedbackLabel={t('vacancies:labels.additionalInterviewFeedback')}
            isAddedAdditionalInterview={isAddedAdditionalInterview}
            hideActionButtons={hideActionButtons}
            fields={fields}
          />

          {field.name !== fields.length - 1 && <Separator />}
        </InterviewFormWrapper>
      ))
    }
  </Form.List>
);

export default ApplicantInterviewsFormList;
